import * as React from "react";
import { TextInput as NativeTextInput, TextInputProps as NativeTextInputProps } from "react-native";
import { StyleSheet } from "react-native-unistyles";
import { useTheme } from "@/lib/styling";
import { Theme } from "@/theme";

export type InputProps = NativeTextInputProps;

const Input = React.forwardRef<NativeTextInput, InputProps>(
  ({ style, onFocus, onBlur, ...props }, ref) => {
    const theme = useTheme<Theme>();
    const [isFocused, setIsFocused] = React.useState(false);

    return (
      <NativeTextInput
        ref={ref}
        style={[
          styles.input,
          isFocused && styles.inputFocused,
          style
        ]}
        onFocus={(event) => {
          setIsFocused(true);
          onFocus?.(event);
        }}
        onBlur={(event) => {
          setIsFocused(false);
          onBlur?.(event);
        }}
        placeholderTextColor={theme.colors.mutedForeground}
        {...props}
      />
    );
  }
);

Input.displayName = "Input";
export { Input };

const styles = StyleSheet.create((theme) => ({
  input: {
    backgroundColor: theme.colors.surface,
    borderColor: theme.colors.border,
    borderRadius: theme.borderRadii.m,
    borderWidth: 1,
    color: theme.colors.text,
    elevation: 0,
    fontFamily: theme.typography.fontFamily.body,
    fontSize: theme.textVariants.body.fontSize,
    height: 40,
    paddingHorizontal: theme.spacing.m,
    paddingVertical: theme.spacing.s,
    shadowColor: 'transparent',
    shadowOffset: { width: 0, height: 0 },
    shadowOpacity: 0,
    shadowRadius: 0,
    width: '100%',
  },
  inputFocused: {
    borderColor: theme.colors.primary,
    borderWidth: 2,
  },
}));
